(function () {
  function init() {
    var badges = document.querySelectorAll('.saquito-cores-reais-badge');
    if (!badges.length) return;

    // Find all popup triggers rendered by the theme (not our badge)
    // Take the LAST one with matching text — gives us the regular popup
    // (siblings popup comes first in DOM; regular popup next to swatch comes after)
    var badgeText = badges[0].textContent.trim().toLowerCase();
    var realTriggers = Array.from(
      document.querySelectorAll('[data-popup-trigger]:not(.saquito-cores-reais-badge)')
    );

    var realTrigger = null;
    realTriggers.forEach(function (t) {
      if (t.textContent.trim().toLowerCase() === badgeText) {
        realTrigger = t; // keeps overwriting → ends up with last match
      }
    });
    // Fallback: any popup trigger that isn't ours
    if (!realTrigger && realTriggers.length) {
      realTrigger = realTriggers[realTriggers.length - 1];
    }

    if (realTrigger) {
      var modalId = realTrigger.getAttribute('data-modal-content-id');
      badges.forEach(function (badge) {
        badge.setAttribute('data-modal-content-id', modalId);
      });
    }

    // Mobile: touchend bypasses gallery touch handlers
    badges.forEach(function (btn) {
      btn.addEventListener('touchend', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        setTimeout(function () { btn.click(); }, 0);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
